import * as React from 'react';
import { IconProps } from '../types';

const IcImportantNote = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
   <rect width={24} height={24} x={0.283} fill={props?.fill ?? '#232F3E'} rx={12} />
    <path
      fill="#fff"
      d="M13.783 4.5v9c0 .826-.674 1.5-1.5 1.5s-1.5-.674-1.5-1.5v-9h3Zm-1.5 12c.826 0 1.5.674 1.5 1.5s-.674 1.5-1.5 1.5-1.5-.674-1.5-1.5.674-1.5 1.5-1.5Z"
    />
  </svg>
);

export default IcImportantNote;